<script>
export default {
  methods: {
    formaPagoNombre(id) {
      const item = this.$store.getters['FormasPagos/all'].find(item => item.id === id)
      return item ? item.nombre : 'Sin forma de pago'
    }
  }
};
</script>
